import {
  Collapse,
  Tag,
  Typography,
} from "antd";


const { Panel } = Collapse;
const { Text } = Typography;
const TextosDinamicosItem = ({ textos }) => (
  <Collapse ghost style={{ backgroundColor: "#fafafa", borderRadius: "5px", marginBottom: "16px" }}>
    <Panel header="Ver textos dinámicos disponibles para el mensaje" key="1">
      {textos.map(({ key, desc }) => (
        <div key={key} style={{ marginBottom: 6 }}>
          <Tag color="blue">{key}</Tag>
          <Text type="secondary" style={{ marginLeft: 4 }}>
            {desc}
          </Text>
        </div>
      ))}
    </Panel>
  </Collapse>
);

 export default TextosDinamicosItem; 